import React from 'react';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { selectIsMeSubscribedToSummary } from 'state/selectors';
import { Tooltip } from '@web-chat-core/ui-kit';
import { SummaryButtonLayout, SummaryIcon } from './view';

interface Props {
    onClick(): void;
    isMobile?: boolean;
}

export const StopSummaryButton: React.FC<Props> = observer(({ onClick, isMobile }) => {
    const { t } = useTranslation();
    const isMeInitiator = selectIsMeSubscribedToSummary();

    const label = isMeInitiator
        ? t('web_videoconference_AI_Assistant_turn_off_tooltip_button')
        : t('videoconference_AI_Assistant_guest_turned_on');

    return (
        <Tooltip label={label}>
            <SummaryButtonLayout disabled={!isMeInitiator} $isActive $isMobile={isMobile} onClick={onClick}>
                <SummaryIcon $isActive icon="icAINotes" size={24} />
            </SummaryButtonLayout>
        </Tooltip>
    );
});
